<!--
 * @Author: xuhuining
 * @Date: 2022-03-23 17:36:21
 * @LastEditors: taoyan taoyan_work@163.com
 * @LastEditTime: 2022-11-24 08:56:33
 * @Description: 更多工具
 * 默认工具排序：固定: 产品溯源、扫码积分、热门活动(1,2,3)
 *               健康问诊、专家问答、生长曲线、喂养记录、能不能吃(4,5,6,7)
 *               疫苗时间表、营养厨房、产检时间表  (8,9,10,11)
-->
<template>
  <div v-if="dataShow" class="more_tools">
    <div class="title">
      <img alt src="../../../assets/images/tools/MoreTools/reverse_back.png" @click="goBack"/>
      <span class="edit" @click="editClick()">{{ editFlag ? '编辑' : '完成' }}</span>
    </div>
    <!-- 首页工具 -->
    <div v-for="item in moreToolsList.slice(0, 1)" :key="item.id" class="more_tools_box">
      <div class="name">
        <img alt src="../../../assets/images/tools/MoreTools/gj_xing.png"/>
        {{ item.name }}
      </div>
      <div class="tools_content">
        <vuedraggable
            v-model="item.itemList"
            :delay="1"
            :disabled="editFlag"
            :fallbackTolerance="3"
            :move="onMove"
            class="wrapper"
            filter=".forbid"
        >
          <transition-group>
            <div
                v-for="(v, index) in item.itemList"
                :key="v.id"
                :class="(v.isUpdate === 1 ) ? 'item forbid' : 'item'"
                class="item"
                @click.stop="isLoginOrEdit(v)"
            >
            <img class="img_tag" v-if="v.imgUrlMini && editFlag" :src=v.imgUrlMini alt="">
              <div v-if="v.urlType !== 3">
                <div :style="{backgroundImage: 'url(' + v.imgUrl +')'}" class="img"></div>
                <span>{{ v.name }}</span>
                <div v-if="!editFlag" class="edit_img">
                  <div v-if="v.state == 3" class="img" @click.stop="subtractClick(v, index)"></div>
                </div>
              </div>
              <div v-if="v.urlType === 3" class="gotoMINI"  @click="issystem ? goToMini('xmyxItem' + v.toolId + item.keyDesc + v.jumpUrl, v.jumpUrl, v.miniProgramType) : ''">
                <div v-if="!issystem" class="gotoMINI-img"  >
                  <openWxTag :id="('xmyxItem' + v.toolId + item.keyDesc)"
                    :path="v.jumpUrl"
                    :appId="v.miniProgramTypeAppId"
                    btnStyle="width:40px;height:40px">
                  </openWxTag>
                </div>
                <div :style="{backgroundImage: 'url(' + v.imgUrl +')'}" class="img"></div>
                <span>{{ v.name }}</span>
                <div v-if="!editFlag" class="edit_img">
                  <div v-if="v.state == 3" class="img" @click.stop="subtractClick(v, index)"></div>
                </div>
              </div>
            </div>
          </transition-group>
        </vuedraggable>
      </div>
    </div>
    <!-- 其他工具 -->
    <div v-for="item in moreToolsList.slice(1)" :key="item.id" class="more_tools_box">
      <div class="name">
        <img alt src="../../../assets/images/tools/MoreTools/gj_xing.png"/>
        {{ item.name }}
      </div>
      <div class="tools_content">
        <div
            v-for="(v, index) in item.itemList"
            :key="v.id"
            class="item"
            @click.stop="isLoginOrEdit(v)"
        >
          <img class="img_tag" v-if="v.imgUrlMini && editFlag" :src=v.imgUrlMini alt="">
          <div v-if="v.urlType !== 3">
            <div :style="{backgroundImage: 'url(' + v.imgUrl +')'}" class="img"></div>
          <span>{{ v.name }}</span>
            <div v-if="!editFlag" class="edit_img">
              <div v-if="v.state == 3" class="img" @click.stop="subtractClick(v, index)"></div>
            </div>
          </div>
          <div v-if="v.urlType === 3" class="gotoMINI"  @click="issystem ? goToMini('xmyxItem' + v.toolId + item.keyDesc + v.jumpUrl, v.jumpUrl, v.miniProgramType) : ''">
            <div v-if="!issystem" class="gotoMINI-img" >
              <openWxTag :id="('xmyxItem' + v.toolId + item.keyDesc)"
                :path="v.jumpUrl"
                :appId="v.miniProgramTypeAppId"
                btnStyle="width:40px;height:40px">
              </openWxTag>
            </div>
            <div :style="{backgroundImage: 'url(' + v.imgUrl +')'}" class="img"></div>
          <span>{{ v.name }}</span>
            <div v-if="!editFlag" class="edit_img">
              <div v-if="v.state == 3" class="img" @click.stop="subtractClick(v, index)"></div>
            </div>
          </div>
          <div v-if="!editFlag" class="edit_img">
            <div v-if="v.state == 2" class="img2" @click.stop="addClick(v, index)"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 健康问诊登录弹窗 -->
    <loginTip
        :closeText="'狠心放弃'"
        :messageText="''"
        :okText="'立即领取'"
        :show="checkLogin"
        :tipstr="'成为会员，立刻尊享免费问诊权益哟～(๑•ᴗ•๑)♡'"
        @cancleWay="cancleWay"
        @confirmWay="confirmWay"
    ></loginTip>
    <!-- 扫码提示弹窗 -->
    <granary-dialog v-show="dialogShow" @closeDialog="cancelDialog" @wxScanFn="weiScanSHnader()"></granary-dialog>
    <!-- 编辑按钮 未注册 登录弹窗 -->
    <registerCard
        v-if="registerFlag"
        :imgUrl="require('@/assets/images/nweHome/toast1.png')"
        text="注册后可享受定制化服务 赶紧注册享受VIP服务吧"
        @close="registerClose"
    ></registerCard>
  </div>
</template>
<script>
import vuedraggable from "vuedraggable";
// import moreToolsData from "../../../utils/mockData/moreToolsData"; // 更多工具数据
import newToolsData from '../../../utils/mockData/newToolsData'
import loginTip from "@/views/contents/calendar/component/logintip"; // 注册提示组件
import granaryDialog from "@/components/contents/granaryDialog.vue"; // 扫码积分弹窗
import registerCard from "@/components/home/registerCard.vue"; // 未注册 VIP 弹窗
import {getBabyMonth, getCookie, globalGoLogin, isUserEdit, setCookie} from "@/assets/js/common.js";
import {getToolSort} from '@/assets/js/toolCardCommon'
import API from '@/utils/axiosApi/newToolApi.js'
import { TestUserAgent, goToMini, globalGologinEdit } from "@/assets/js/common.js";
import openWxTag from "@/components/common/openWeappTag/index.vue";
import { log } from 'console';

export default {
  name: "moreTools",
  components: {vuedraggable, loginTip, granaryDialog, registerCard, openWxTag},
  data() {
    return {
      editFlag: true, // 编辑状态
      checkLogin: false, // 健康问诊弹窗
      dialogShow: false, // 扫码提示弹窗
      userInfo: null, // 用户信息
      registerFlag: false, // 编辑按钮未注册 弹窗
      babyNum: null, // 宝宝胎次
      babyCustomizationFlag: false, // 是否定制过宝宝
      itemBabyInfo: {}, // 首页展示的宝宝信息
      toolsId: "",
      dataShow: false, //接口返回渲染的变量
      moreToolsList: [],
      issystem: TestUserAgent().isios,
    };
  },
  created() {
    sessionStorage.removeItem('feedTag')
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.babyNum = this.getCookie("babyNum");
    this.getBabyState(this.babyNum)
    this.getUserTool(this.babyNum)
    if (this.userInfo != null) { // 登录状态
      // this.getUserTool(this.babyNum); // 获取首页工具排序顺序
    } else { // 未登录
      // this.moreToolsList[0].toolsSortNum = [6, 7, 36, 35, 3, 4, 32, 33, 8]; //扫码积分和产品溯源排在最前面不变
      // this.toolsSort(this.moreToolsList[0].toolsSortNum, 0);
      this.babyCustomizationFlag = false;
    }
    // this.restsToolsSort(); // 其他工具排序
    var shareDataParams = {
      // shareLink: this.$http.hostName + "/home",
      shareLink: location.href.split("#")[0],
      shareDesc: "养娃所需要的工具，这里全都有，生长曲线、在线问诊、能不能吃、扫码积分~解决你的育儿烦恼",
      shareTitle: "育儿工具",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
    };
    var that = this;
    that.wxJsSet.wxShare("fx", shareDataParams, that);
    let aaa = this.userInfo == null ? '未登录' : this.babyCustomizationFlag ? '登录已定制' : '登录未定制'
    console.log(aaa, '用户状态')
  },
  updated() {
    // 拖动排序的id
    var arr = [];
    for (let v of this.moreToolsList[0].itemList) {
      arr.push(v.id);
    }
    this.moreToolsList[0].toolsSortNum = arr;
  },
  methods: {
    goToMini,
    // 判断是否登录 是否定制
    // 3生长曲线  8疫苗时间表 17产检提醒 21喂养记录  未定制去定制
    isLoginOrEdit(item) {
      if (this.userInfo != null) { // 已登录
        if (this.babyCustomizationFlag) { // 已定制
          if (this.editFlag) { // 未编辑状态
            this.toTool(item);
          }
        } else { // 未定制
          if (item.id === 3 || item.id === 8 || item.id === 17 || item.id === 21) {
            this.goEdit();
          } else {
            this.toTool(item);
          }
        }
      } else { // 未登录
        if (item.id === 3 || item.id === 8 || item.id === 17 || item.id === 21 || item.id === 36) {
          this.goLogin();
        } else {
          this.toTool(item);
        }
      }
      let obj = {tool_name: item.name, Baby_Month: getBabyMonth(),JumpMiniprogram:item.miniProgramTypeName}
      this.sensorsFn('xingmahui_moretools_click', obj)
    },
    // 跳转工具
    toTool(item) {
      console.log('跳转工具需要判断的参数', this.userInfo, isUserEdit(), )
      let { num, birth, } = this.itemBabyInfo
      console.log(num,birth, '参数1111')
      if(item.isLogin === 0 && !this.userInfo){
        console.log('未登录去登录')
        this.goLogin();
        return
      }
      if(item.isCustomize === 0 && !isUserEdit()){
        console.log('未定制去定制')
        this.goEdit();
        return
      }
      let babyInfo = JSON.parse(localStorage.getItem("babyInfo")) || [];
      let babyNums = JSON.parse(localStorage.getItem("babyNums")) || 1;
      let first = babyInfo.length > 0 && babyInfo[0].tag_id ? babyInfo[0].tag_id : ""
      let second = babyInfo.length > 1 && babyInfo[1].tag_id ? babyInfo[1].tag_id : ""
      let tag_id_api = babyNums == 1 ? first : second
      if(tag_id_api && item.toolMonthAge.indexOf(tag_id_api) == -1 ){
        this.$toast("抱歉，当前月龄无法使用该工具哦~");
        return
      }
      switch(item.urlType) {
        case 1:// 站内链接
          let { num, birth } = this.itemBabyInfo
          // console.log(num,birth, '参数11115',this.itemBabyInfo.tag_id)
          if(this.itemBabyInfo.tag_id > 2){
            let { monthAge , month} = JSON.parse(localStorage.getItem("babyGrowdate"))
            if(item.jumpUrl.indexOf('?') > -1){
              item.jumpUrl = item.jumpUrl + (item.jumpUrl.indexOf('from=') != -1? '' : '&from=moreTools') + '&sourceFrom=moreTools' + '&source=moreTools' +'&num=' + num + '&bir=' + birth + '&monthAge=' + monthAge + '&month=' + month
            }else{
              item.jumpUrl = item.jumpUrl + (item.jumpUrl.indexOf('from=') != -1? '' : '?from=moreTools') + '&sourceFrom=moreTools'+ '&source=moreTools' +'&num=' + num + '&bir=' + birth + '&monthAge=' + monthAge + '&month=' + month
            }
          }else {
            if(item.jumpUrl.indexOf('?') > -1){
              item.jumpUrl = item.jumpUrl + (item.jumpUrl.indexOf('from=') != -1? '' : '&from=moreTools') + '&sourceFrom=moreTools'+ '&source=moreTools' +'&num=' + num + '&bir=' + birth
            }else{
              item.jumpUrl = item.jumpUrl + (item.jumpUrl.indexOf('from=') != -1? '' : '?from=moreTools') + '&sourceFrom=moreTools'+ '&source=moreTools' +'&num=' + num + '&bir=' + birth
            }
          }

          console.log(item.jumpUrl,'拼接参数后跳转的站内链接地址')
          this.$router.push({path : item.jumpUrl})
          break
        case 2:// 站外链接
          location.href = item.jumpUrl
          // location.href = 'https://chengzhangxiangce.feihe.com/weixin.php?channel_id=4'
          break
      }


      // switch (item.id) {
      //   case  1: // 育儿宝典
      //   case  10: // 备孕宝典
      //   case  15: // 孕期宝典
      //     this.$router.push({path: item.link + '?from=moreTools'})
      //     break
      //   case  2: // 宝宝食谱
      //   case  9: // 能不能吃
      //   case  13: // 专家问答
      //   case  25: // 营养厨房
      //   case  26: // 宝宝辅食
      //   case  28: // 育儿问答
      //     this.$router.push({path: item.link})
      //     break
      //   case  3: // 生长曲线 参数 num：当前宝宝胎次
      //     this.$router.push({path: item.link + "?sourceFrom=moreTools&num=" + this.itemBabyInfo.num});
      //     break
      //   case  4: // 儿歌故事
      //   case  11: // 助眠音乐
      //   case  16: // 胎教音乐
      //   case  22: // 哄睡儿歌
      //     this.$router.push({path: item.link, query: {from: "song", source: "moreTools"}})
      //     break
      //   case  5: // 宝宝相册
      //   case  14: // 云相册
      //   case  18: // 孕期相册
      //     location.href = 'https://chengzhangxiangce.feihe.com/weixin.php?channel_id=4'
      //     break
      //   case  6: // 扫码积分
      //     this.weiScanSHnader()
      //     break
      //   case  7: // 产品溯源
      //     location.href = 'http://wic.feihe.com/review/front/review/sweep?source=1'
      //     break
      //   case  8: // 疫苗时间表 备孕和孕期点击提示toast文案 参数 num：当前宝宝胎次  bir: 当前宝宝生日
      //     if (this.itemBabyInfo.tag_id > 2) {
      //       this.$router.push({path: item.link + "?num=" + this.itemBabyInfo.num + "&bir=" + this.itemBabyInfo.birth});
      //     } else {
      //       this.$toast("需要先有宝宝才能使用哦~");
      //     }
      //     break
      //   case  12: // 备孕问诊
      //             // case  23: // 育儿问诊
      //             // case  24: // 家庭问诊
      //             // case  27: // 母婴问诊
      //             // case  29: // 孕期问诊
      //     if (this.userInfo == null || this.userInfo == "" || this.userInfo.mobile == null || this.userInfo.mobile == "" || this.userInfo.mobile == "null") {
      //       this.checkLogin = true
      //     } else {
      //       this.$router.push({path: "/lineDoctor?utm_campaign=XMH_H5_HOME_ICON"})
      //     }
      //     break
      //   case  17: // 产检提醒 参数 num：当前宝宝胎次  bir: 当前宝宝生日
      //     if (this.itemBabyInfo.tag_id == 1) {
      //       this.$toast("需要怀孕了才能用哦~");
      //     } else {
      //       this.$router.push({path: item.link + "?num=" + this.itemBabyInfo.num + "&bir=" + this.itemBabyInfo.birth})
      //     }
      //     break
      //   case  21: // 喂养记录 未定制去定制 备孕和孕期点击提示toast文案 参数 num：当前宝宝胎次  monthAge：    month:
      //     if (this.itemBabyInfo.tag_id > 2) {
      //       const babyDays = JSON.parse(localStorage.getItem("babyGrowdate"))
      //       this.$router.push({path: item.link + "?num=" + this.itemBabyInfo.num + "&monthAge=" + babyDays.monthAge + "&month=" + babyDays.month});
      //     } else {
      //       this.$toast("需要先有宝宝才能使用哦~");
      //     }
      //     break
      //   case  30: // 星牧场
      //     location.href = 'https://2022xingmuchang.feihe.com/weixin.php?channel_id=29'
      //     break;
      //   case  32: // 奶粉百科
      //     this.$router.push({path: "/powderedMilk"})
      //     break;
      //   case 31:
      //     location.replace(location.origin + '/member/splitBlindBox?result=tool')
      //     break
      //   case  33: //营养测评
      //     location.href = 'https://www.wjx.cn/vm/rZ1ECPI.aspx'
      //     break;
      //   case  34: //辅食测评
      //     location.href = 'https://www.wenjuan.ltd/s/muQn6jT/#'
      //     break;
      //   case  36: // 0元试用
      //     this.$router.push({ path: "/trialProducts" })
      //     break;
      //   case  35: // 喂养之道
      //     this.$router.push({path: "/babyFeeding"})
      //     break;
      // }
    },
    // 禁止拖动的元素
    onMove(e) {
      const {id, isUpdate} = e.relatedContext.element;
      if (isUpdate === 1) return false;
      return true;
    },
    // 查询全部工具接口
    getUserTool(babyNum) {
      let babyInfo = JSON.parse(localStorage.getItem("babyInfo")) || [];
      let babyNums = JSON.parse(localStorage.getItem("babyNums")) || 1;
      let first = babyInfo.length > 0 && babyInfo[0].tag_id ? babyInfo[0].tag_id : ""
      let second = babyInfo.length > 1 && babyInfo[1].tag_id ? babyInfo[1].tag_id : ""
      let tag_id_api = babyNums == 1 ? first : second
      console.log(babyNums,babyInfo,'宝宝信息')

       //接口参数
       let Toolparams = {
        crmId: this.userInfo ? this.userInfo.crm_id : '', // crmID
        parityNum: this.babyNum, // 胎次
        monthAge: tag_id_api // 月龄段
      }
      // 查询全部工具接口
      API.getAllToolsList({},{...Toolparams}, (res) => {
        console.log('接口数据', res.data)
        if (res.code == 200) {
          this.dataShow = true
          res.data.map((item,index) => {
            item.id = index
            item.name = item.keyDesc
            item.dataList.map(ite => {
              ite.id = ite.toolId
            })
            item.toolsSortNum = item.dataList.map(item => item.toolId)
          })
          res.data[0].dataList.map(item => {
            item.state = item.isUpdate == 0 ? '3' : '1'
          })
          // this.moreToolsList = res.data


          // {
          //   id: 0,
          //   name: "首页展示工具",
          //   toolsSortNum: [],
          //   itemList: []
          // },
          res.data.map(item => {
            item.itemList = item.dataList
            item.toolsSortNum = item.dataList.map(item => item.id)
          })
          this.moreToolsList = res.data


          console.log(this.moreToolsList,'全部数据11111111111')
          let toolsArray = JSON.parse(res.data.map(item => item.id));
          this.toolsSort(toolsArray, 0);
          // this.toolsId = res.data.id;
          this.getBabyState(babyNum);

           // 赋值操作
          // var toolsArray = JSON.parse(res.data.toolsArray);
          // this.toolsSort(toolsArray, 0);
          // this.moreToolsList[0].toolsSortNum = toolsArray;
          // this.toolsId = res.data.id;
          // this.babyCustomizationFlag = true;
          // this.getBabyState(babyNum);


        }
      })

      // if (isUserEdit()) {
      //   this.$http.get(
      //       "/userTools/getUserTool",
      //       {
      //         crmId: this.userInfo.crm_id,
      //         parityNum: babyNum
      //       },
      //       res => {
      //         // 编辑过的工具排序
      //         if (res.code == "200" && res.data != null) {

      //           var toolsArray = JSON.parse(res.data.toolsArray);
      //           this.toolsSort(toolsArray, 0);
      //           this.moreToolsList[0].toolsSortNum = toolsArray;
      //           this.toolsId = res.data.id;
      //           this.babyCustomizationFlag = true;
      //           this.getBabyState(babyNum);
      //         } else {
      //           // 没有编辑过的工具状态
      //           this.getBabyState(babyNum, 2);
      //         }
      //       }
      //   )
      // } else {
      //   this.moreToolsList[0].toolsSortNum = [6, 7, 36, 35, 3, 4, 32, 33, 8];
      //   this.toolsSort(this.moreToolsList[0].toolsSortNum, 0);
      // }
    },
    // 获取宝宝孕育状态  type=2 ：没有编辑过工具
    getBabyState(num, type) {
      num = num == null ? 1 : num;
      var babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      console.log('宝宝信息',babyInfo)
      if (babyInfo) { //本地存储的宝宝信息
        if (this.babyNum == null && babyInfo.length == 1) {
          this.setCookie("babyNum", 1, 30);
        }
        // this.getBabyTools(num, babyInfo);
        for (let v of babyInfo) {
          if (num == v.num) {
            this.itemBabyInfo = v
          }
        }
        this.babyCustomizationFlag = true;
      } else {
        this.$http.get(
            "/starMom/getBaby",
            {crmId: this.userInfo ? this.userInfo.crm_id : ''},
            res => {
              // this.getBabyTools(num, res.data);
              if (res.code == "200" && res.data.length != 0) {
                if (this.babyNum == null && res.data.length == 1) {
                  this.setCookie("babyNum", 1, 30);
                }
                // 最开始默认的工具排序

                for (let v of res.data) {
                  if (num == v.num) {
                    this.itemBabyInfo = v
                  }
                }
                this.babyCustomizationFlag = true;
              } else {
                // if (type == 2) {
                //   this.moreToolsList[0].toolsSortNum = [6, 7, 1, 35, 3, 4, 32, 33, 8];
                //   this.toolsSort(this.moreToolsList[0].toolsSortNum, 0);
                // }
                this.babyCustomizationFlag = false;
              }
            },
            err => {
            }, "member"
        );
      }
    },
    // 默认宝宝对应的孕育状态的工具排序
    getBabyTools(num, babyInfo) {
      for (let i = 0; i < babyInfo.length; i++) {
        if (num == babyInfo[i].num) {
          console.log(1111452, babyInfo[i].tag_id);
          this.getToolSort(babyInfo[i].tag_id)
        }
        this.toolsSort(this.moreToolsList[0].toolsSortNum, 0);
      }
    },

    // 根据当前宝宝月龄确定默认首页工具
    getToolSort(tagid) {
      console.log(111, tagid);
      // tagid: 1是备孕，2是怀孕，3是0-6月，4是6-12月，5是12-36月，6是36月以上
      this.moreToolsList[0].toolsSortNum = getToolSort(tagid)
    },

    // 其他工具排序
    // restsToolsSort() {
    //   for (let i = 1; i < this.moreToolsList.length; i++) {
    //     this.toolsSort(this.moreToolsList[i].toolsSortNum, i);
    //   }
    // },
    // 展示工具排序
    toolsSort(arr, index) {
      var list = newToolsData.toolsList;
      var list2 = [];
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (arr[i] == list[j].id) {
            // if (list[j].id == 6 || list[j].id == 7) {
            //   list[j].state = "1";
            //   list2.push(JSON.parse(JSON.stringify(list[j])));
            // } else {
            //   list[j].state = "3";
            //   list2.push(JSON.parse(JSON.stringify(list[j])));
            // }
          }
        }
        this.moreToolsList[index].itemList = list2;
      }
    },
    // 编辑/完成
    editClick() {
      console.log(this.userInfo, this.babyCustomizationFlag,'用户状态')
      if (this.userInfo != null) {
        if (!this.babyCustomizationFlag) {
          this.sensorsFn('xingmahui_moretools_edit_click', {})
          this.$toast("完善宝宝信息才能使用哦~");
          return
        }
        console.log(this.babyNum ,'宝宝月龄')
        // 定制状态
        console.log(this.babyCustomizationFlag, '定制状态')
        if (this.babyCustomizationFlag) {
          this.editFlag = !this.editFlag;
          if (!this.editFlag) {
            this.sensorsFn('xingmahui_moretools_edit_click', {})
            this.dataProcessing();
          } else {
             //接口参数
              let Toolparams = {
                crmId: this.userInfo ? this.userInfo.crm_id : '', // crmID
                parityNum: this.babyNum, // 胎次
                toolsIds: this.moreToolsList[0].toolsSortNum
              }
            // 编辑用户自定义工具
            console.log('编辑接口', Toolparams,this.itemBabyInfo)
            API.exitUserTools({},{...Toolparams}, (res) => {
              console.log(res,'编辑接口数据')
              if (res.code == "200") {
                let toolName = []
                for (let v of this.moreToolsList[0].itemList) {
                  toolName.push(v.name)
                }
                let obj = {tool_name: toolName.join()}
                this.sensorsFn('xingmahui_moretools_done_click', obj)
                this.getUserTool(this.babyNum);
                }
            })



            // this.$http.post(
            //     "/userTools/saveUserTool",
            //     {},
            //     {
            //       id: this.toolsId,
            //       crmId: this.userInfo.crm_id,
            //       parityNum: this.babyNum,
            //       toolsArray: JSON.stringify(this.moreToolsList[0].toolsSortNum)
            //     },
            //     res => {
            //       let toolName = []
            //       for (let v of this.moreToolsList[0].itemList) {
            //         toolName.push(v.name)
            //       }
            //       let obj = {tool_name: toolName.join()}
            //       this.sensorsFn('xingmahui_moretools_done_click', obj)
            //       if (res.code == "200" && this.toolsId == "") {
            //         this.getUserTool(this.babyNum);
            //       }
            //     }
            // );
          }
        }
      } else {
        this.sensorsFn('xingmahui_moretools_edit_click', {})
        this.registerFlag = true;
      }
    },
    // 加
    addClick(item) {
      if (this.moreToolsList[0].itemList.length == 9) {
        this.$toast("首页最多添加9个工具哦~");
      } else {
        let obj = JSON.parse(JSON.stringify(item));
        obj.state = "3";
        this.moreToolsList[0].toolsSortNum.push(obj.id);
        this.moreToolsList[0].itemList.push(obj);
        this.dataProcessing();
      }
    },
    // 减
    subtractClick(item, index) {
      this.moreToolsList[0].itemList.splice(index, 1);
      this.moreToolsList[0].toolsSortNum.splice(index, 1);
      this.dataProcessing();
    },
    // 加减图标控制
    dataProcessing() {
      for (let i = 1; i < this.moreToolsList.length; i++) {
        for (let b of this.moreToolsList[i].itemList) {
          if (this.moreToolsList[0].toolsSortNum.indexOf(b.id) == -1) {
            b.state = "2";
          } else {
            b.state = "1";
          }
        }
      }
    },
    // 跳转登录
    goLogin() {
      var that = this;
      setTimeout(function () {
        // that.$router.push({
        //   path: "/phoneLogin?redirect=" + window.location.href
        // });
        globalGoLogin()
      }, 200);
    },
    // 跳转定制
    goEdit() {
      globalGologinEdit({from: 'moreTools'})
      // var that = this;
      // setTimeout(function () {
      //   // that.$router.push({
      //   //   path: "/loginEdit?redirect=" + window.location.href
      //   // });
      //   location.href = location.origin + "/member/loginEdit?redirect=" + window.location.href + '&title=' + that.$route.meta.title
      // }, 200);
    },
    //微信扫码
    weiScanSHnader() {
      // if (!localStorage.getItem("isWxScan")) {
      //   this.dialogShow = true;
      //   localStorage.setItem("isWxScan", true);
      // } else {
      this.dialogShow = false;
      localStorage.setItem("sweep_source", "更多工具页面");
      // this.$router.push({ path: "/sweep" });
      location.href = location.origin + '/member/sweep?type=moreTools'
      // }
    },
    // 取消扫码提示弹窗
    cancelDialog: function (flag) {
      this.dialogShow = flag;
    },
    // 健康问诊弹窗
    confirmWay() {
      this.checkLogin = false;
      this.goLogin();
    },
    cancleWay() {
      this.checkLogin = false;
    },
    // 注册享受VIP弹窗 关闭
    registerClose() {
      this.registerFlag = false;
    },
    goBack() {
      this.$router.push("/home");
    },
    // 埋点
    sensorsFn(type, obj) {
      const {tag_id, sex} = this.itemBabyInfo
      console.log(tag_id,sex,98765)
      sensors.track(type, {
        registered_state: this.userInfo == null ? '未登录' : this.babyCustomizationFlag ? '登录已定制' : '登录未定制',
        baby_state: tag_id == undefined ? '无' : tag_id == 1 ? '备孕' : tag_id == 2 ? '怀孕' : sex == 'M' ? '小王子' : '小公主',
        ...obj
      })
    },
    getCookie,
    setCookie
  }
};
</script>
<style lang="less" scoped>
.more_tools {
  width: 343px;
  margin: auto;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 46px;

    img {
      width: 10px;
      height: 18px;
    }

    .edit {
      font-size: 16px;
      color: #ff9d6e;
    }
  }

  .more_tools_box {
    width: 100%;
    border-radius: 8px;
    background: #ffffff;
    padding: 14px 10px 14px 12px;
    box-sizing: border-box;
    margin-bottom: 8px;

    .gotoMINI {
      position: relative;
    }
    .gotoMINI-img {
      position: absolute;
      top: 0;
      left: 12px;
    }
    .name {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      display: flex;
      align-items: center;

      img {
        width: 19px;
        height: 18px;
        display: block;
        padding-right: 1px;
      }
    }

    .tools_content {
      width: 100%;
      margin-top: 6px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .wrapper {
        span {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
        }
      }

      .item {
        width: 64px;
        height: 59px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        align-items: center;
        margin-top: 14px;
        position: relative;
        .img_tag{
          width: 44px;
          height: 13px;
          position: absolute;
          right:-14px;
          top: -8px;
          z-index: 10;
        }
        .img {
          width: 38px;
          height: 38px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: cover;
          margin-left: 12px;
        }

        span {
          font-size: 12px;
          color: #333333;
          display: inline-block;
          width: 62px;
          text-align: center;
          margin-top: 5px;
        }

        .edit_img {
          position: absolute;
          top: -2px;
          right: 7px;

          div {
            width: 16px;
            height: 16px;
          }

          .img {
            background: url(../../../assets/images/tools/MoreTools/gj_subtract.png) no-repeat center center;
            background-size: cover;
          }

          .img2 {
            background: url(../../../assets/images/tools/MoreTools/gj_add.png) no-repeat center center;
            background-size: cover;
          }
        }
      }
    }
  }
}
</style>
